import React, { useRef } from 'react';
import ballImage from '../../assets/img/icon/ball_icon.png';
import { useTranslation } from 'react-i18next';

function TableWrapper({title, children, id, trackmanYn}) {
    const { t } = useTranslation();

    return (
        <div className="tableBox">
            <div className="tableTitle">
                <img src={ballImage} alt='#'/> {t(title)}
                <span id={id+"_stat"}></span>
                {
                    trackmanYn ?
                    <span className="statDetail">{t("(T)Means")}</span>
                    :
                    ''
                }
            </div>
            <div className="tableDiv">
                {children}
            </div>
        </div>
    )
}

export default TableWrapper;